<template>
  <div class="load-more" v-if="showLoadMore"><span>{{ $t('loadMore') }}</span></div>
</template>

<script>
  import locales from './lang'

  export default {
    name: 'load-more',
    props: {
      currentPage: {
        type: Number,
        default: 1,
        required: true
      },
      totalPage: {
        type: Number,
        default: 1,
        required: true
      },
      loading: {
        type: Boolean,
        default: false,
        required: true
      }
    },
    locales,
    computed: {
      showLoadMore() {
        return !this.loading && this.totalPage > this.currentPage
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  * {
    padding: 0;
    margin: 0;
  }
  .load-more {
    margin: .08rem auto .24rem;
    width: 260px;
    height: 49px;
    line-height: 49px;
    font-size: 16px;
    text-align: center;
    font-weight: 600;
    position: relative;
    border-radius: 100px;
    background: url('/static/img/downloadNew/gradient_btn_bg.png') 0 / 100%;
    span {
      background: -webkit-linear-gradient(0deg, #416CF8, #EC55FF);
      -webkit-text-fill-color: transparent;
      -webkit-background-clip: text;
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// LoadMore.vue?11f424d3